import { default as AntBreadcrumb } from "antd/lib/breadcrumb";
import { default as AntBreadcrumbItem } from "antd/lib/breadcrumb/BreadcrumbItem";

import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";

export function Breadcrumb({
  children,
}: {
  readonly children?: React.ReactNode;
}) {
  return (
    <Breadcrumb.Container>
      <AntBreadcrumb>{children}</AntBreadcrumb>
    </Breadcrumb.Container>
  );
}

export namespace Breadcrumb {
  export const Item = AntBreadcrumbItem;
  export const Container = styled.div`
    & .ant-breadcrumb a {
      color: ${() => Color.azure()};
    }
  `;
}
